export default __webpack_public_path__ + "static/middleware-060c82696cb0b9578a38af3da3fdda9a.png";